// removed by extract-text-webpack-plugin
module.exports = {"container":"root-module__container___q7OCb","wrapper":"root-module__wrapper___13Vcp","app":"root-module__app___2VllN","legend":"root-module__legend___3pIOt"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/root/root.module.scss
// module id = 1323
// module chunks = 0